








import Vue from 'vue';

import Anon from '@/layouts/Anon.vue';
import AnonDark from '@/layouts/AnonDark.vue';
import Default from '@/layouts/Default.vue';
import None from '@/layouts/None.vue';

export default Vue.extend( {
	components: {
		'layout-anon': Anon,
		'layout-anon-dark': AnonDark,
		'layout-default': Default,
		'layout-none': None
	},
	computed: {
		ready() {
			return this.$route.name !== null;
		},
		layout() {
			const route = this.$route;
			const layout = route.name ? route.meta?.layout || 'default' : 'none';
			return `layout-${layout}`;
		}
	}
} );
